import { IonIcon } from '@ionic/react';
import { home } from 'ionicons/icons';
import { HStack, VStack } from 'reaction';
import styles from './Titlebar.module.css';
import typeface from 'utils/typeface.module.css';
import brand from 'assets/branding/Viraj Shah Logo.png';

interface TitlebarProps {
    title: string;
}

function Titlebar({ title }: TitlebarProps) {
    return (
        <HStack justify='start' className={styles.Titlebar}>
            <HStack grow={1} justify='start'>
                <a href='/' className={styles.HomeButton}>
                    <IonIcon icon={home} />
                </a>
            </HStack>

            <HStack grow={1}>
                <h1 className={typeface.Title}>{title}</h1>
            </HStack>

            <HStack grow={1} justify='end'>
                <img src={brand} alt='Viraj Shah Brand' className={styles.Brand} />
            </HStack>
        </HStack>
    );
}

export default Titlebar;
export type { TitlebarProps };
